import VuiButton from "components/VuiButton";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import GppGoodIcon from "@mui/icons-material/GppGood";
import ErrorIcon from "@mui/icons-material/Error";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import VuiBox from "components/VuiBox";

export function AppCodeState({ state, responsive = true, codesButtonStates }) {
  const states = {
    1: (
      <VuiButton
        sx={({ breakpoints }) => ({
          width: "100%",
          minWidth: "max-content",
          fontSize: "12px",
          lineHeight: "18px",
          height: "28px",
          background: "rgba(1, 181, 116, 0.12)",
          color: "#01B574",
          cursor: "default",
          textTransform: "none",
          pointerEvents: "none",
          [breakpoints.down("md")]: {
            background: responsive && "transparent",
            width: responsive ? "100%" : "118.685px",
          },
          "&:hover": { background: "rgba(1, 181, 116, 0.12)", transform: "none" },
        })}
      >
        <CheckCircleIcon
          sx={{
            marginRight: "5px",
          }}
        />
        <VuiBox
          sx={({ breakpoints }) => ({
            color: "unset",
            [breakpoints.down("md")]: {
              display: responsive && "none",
            },
          })}
        >
          {codesButtonStates.active}
        </VuiBox>
      </VuiButton>
    ),
    2: (
      <VuiButton
        sx={({ breakpoints }) => ({
          width: "100%",
          minWidth: "max-content",
          fontSize: "12px",
          lineHeight: "18px",
          height: "28px",
          background: "transparent",
          color: "#FFF",
          cursor: "default",
          textTransform: "none",
          border: "solid 1px #FFF",
          pointerEvents: "none",
          [breakpoints.down("md")]: {
            background: "transparent",
            border: responsive && "none",
            width: responsive ? "100%" : "118.685px",
          },
          "&:hover": { background: "transparent", transform: "none" },
        })}
      >
        <GppGoodIcon
          sx={{
            marginRight: "5px",
            width: "20px",
          }}
        />
        <VuiBox
          sx={({ breakpoints }) => ({
            color: "unset",
            [breakpoints.down("md")]: {
              display: responsive && "none",
            },
          })}
        >
          {codesButtonStates.delivered}
        </VuiBox>
      </VuiButton>
    ),
    0: (
      <VuiButton
        sx={({ breakpoints }) => ({
          width: "100%",
          minWidth: "max-content",
          fontSize: "12px",
          lineHeight: "18px",
          height: "28px",
          background: "#2F323E",
          color: "#FFB547",
          cursor: "default",
          textTransform: "none",
          pointerEvents: "none",
          [breakpoints.down("md")]: {
            background: responsive && "transparent",
            border: responsive && "none",
            width: responsive ? "100%" : "118.685px",
          },
          "&:hover": { background: "#2F323E", transform: "none" },
        })}
      >
        <ErrorIcon
          sx={{
            marginRight: "5px",
          }}
        />
        <VuiBox
          sx={({ breakpoints }) => ({
            color: "unset",
            [breakpoints.down("md")]: {
              display: responsive && "none",
            },
          })}
        >
          {codesButtonStates.undelivered}
        </VuiBox>
      </VuiButton>
    ),
    default: (
      <VuiButton
        sx={({ breakpoints }) => ({
          width: "118.685px",
          fontSize: "12px",
          lineHeight: "18px",
          height: "28px",
          background: "transparent",
          color: "#0075FE",
          cursor: "default",
          textTransform: "none",
          border: "solid 1px #0075FE",
          textTransform: "none",
          pointerEvents: "none",
          [breakpoints.down("md")]: {
            background: responsive && "transparent",
            border: responsive && "none",
          },
          "&:hover": { background: "transparent", transform: "none" },
        })}
      >
        <HelpOutlineIcon
          sx={{
            marginRight: "5px",
          }}
        />
        <VuiBox
          sx={({ breakpoints }) => ({
            color: "unset",
            [breakpoints.down("md")]: {
              display: responsive && "none",
            },
          })}
        >
          {codesButtonStates}
        </VuiBox>
      </VuiButton>
    ),
  };

  return states[state] ?? states["default"];
}
